/*
 * Copyright (c) 2019-2022 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */

import { Flex } from '@getgo/chameleon-chakra-ui';
import React, { useContext } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { SessionContext } from '../../context/SessionContext';
import {
  TelemetryAction,
  TelemetryComponent,
  TelemetryState,
  useSendTelemetry,
} from '../../hooks/useSendTelemetry';
import { buildWebAppJoinUrl } from '../../services/UrlService';
import { Spacing } from '../../themes/GoToTheme';
import { GoToCaption } from '../Texts/GoToCaption';
import { StyledButton } from './StyledButton';
import {
  isRememberMyChoiceSet,
  resetToWebFirstUser,
} from '../../lib/nativeUsageStore';

const messages = defineMessages({
  buttonLabel: {
    id: 'goto.join.button.web.label',
  },
  buttonCaption: {
    id: 'goto.join.button.web.caption',
  },
});

interface Props {
  telemetryState: TelemetryState;
  secondaryButton?: boolean;
}

export const WebJoinButton: React.FC<Props> = (props) => {
  const { formatMessage: f } = useIntl();
  const { meetingId, sessionTrackingId, webAppUrl } =
    useContext(SessionContext);
  const instantJoinUrl =
    webAppUrl || buildWebAppJoinUrl(meetingId, sessionTrackingId);
  const sendTelemetry = useSendTelemetry();

  return (
    <Flex flexDirection='column' width='min-content'>
      <StyledButton
        secondary={props.secondaryButton}
        link={instantJoinUrl}
        onClick={() => {
          sendTelemetry(
            TelemetryComponent.Web,
            TelemetryAction.Join,
            props.telemetryState
          );
          if (isRememberMyChoiceSet()) {
            resetToWebFirstUser();
          }
        }}
      >
        {f(messages.buttonLabel)}
      </StyledButton>
      <GoToCaption marginTop={Spacing.CoreLayout1}>
        {f(messages.buttonCaption)}
      </GoToCaption>
    </Flex>
  );
};
